module.exports = __webpack_public_path__ + "img/phone-outgoing.00dcb379.svg";